import styled from 'styled-components';
import { colors } from '../../constants/colors';

export const Container = styled.div`
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.red11};
`;

export const ErrorText = styled.span`
  color: ${colors.red5};
  font-size: 14px;
  font-weight: 700;
`;
